
module.exports = [
  'M32 16 A16 12 0 0 0 0 16 A16 12 0 0 0 16 28 L18 28 C20 30 24 32 28 32 C27 31 26 28 26 25.375 L26 25.375 A16 12 0 0 0 32 16'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/chat.js
 ** module id = 195
 ** module chunks = 0
 **/